import { _optionalChain } from '@sentry/utils/esm/buildPolyfills';
import { patchWebAssembly } from './patchWebAssembly.js';
import { getImage, getImages } from './registry.js';

/** plz don't */
function patchFrames(frames) {
  let haveWasm = false;
  frames.forEach(frame => {
    if (!frame.filename) {
      return;
    }
    const match = frame.filename.match(/^(.*?):wasm-function\[\d+\]:(0x[a-fA-F0-9]+)$/);
    if (match !== null) {
      const index = getImage(match[1]);
      if (index >= 0) {
        frame.instruction_addr = match[2];
        frame.addr_mode = `rel:${index}`;
        frame.filename = match[1];
        frame.platform = 'native';
        haveWasm = true;
      }
    }
  });
  return haveWasm;
}

/**
 * Process WASM stack traces to support server-side symbolication.
 *
 * This also hooks the WebAssembly loading browser API so that module
 * registraitons are intercepted.
 */
class Wasm  {constructor() { Wasm.prototype.__init.call(this); }
  /**
   * @inheritDoc
   */
   static __initStatic() {this.id = 'Wasm';}

  /**
   * @inheritDoc
   */
   __init() {this.name = Wasm.id;}

  /**
   * @inheritDoc
   */
   setupOnce(addGlobalEventProcessor, _getCurrentHub) {
    patchWebAssembly();

    addGlobalEventProcessor((event) => {
      let haveWasm = false;

      if (event.exception && event.exception.values) {
        event.exception.values.forEach(exception => {
          if (_optionalChain([exception, 'optionalAccess', _ => _.stacktrace, 'optionalAccess', _2 => _2.frames])) {
            haveWasm = haveWasm || patchFrames(exception.stacktrace.frames);
          }
        });
      }

      if (haveWasm) {
        event.debug_meta = event.debug_meta || {};
        event.debug_meta.images = getImages();
      }

      return event;
    });
  }
}Wasm.__initStatic();

export { Wasm };
//# sourceMappingURL=index.js.map
